import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AmplitudeService } from '../../core/services/amplitude.service';
import { LocaleService } from '../services/locale.service';
import { ViewportService } from '../services/viewport.service';

@Component({
	selector: 'app-select-language',
	templateUrl: './select-language.component.html',
	styleUrls: ['./select-language.component.scss'],
})
export class SelectLanguageComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public locale: LocaleService,
		public viewport: ViewportService,
		private dialogRef: MatDialogRef<SelectLanguageComponent>,
		private amplitude: AmplitudeService
	) {}

	onLanguageChange(lang: string) {
		// Amplitude track event
		this.amplitude.trackLanguageSelection(lang);

		this.dialogRef.close(lang);
	}

	ngOnInit(): void {}
}
